import React, { FC } from 'react';
import styled, { css } from 'styled-components';
import { below, media, widthBreakpoints } from 'src/config/breakpoints';
import { useMediaQuery } from 'src/common/migration/useMediaQuery';
import { Button } from 'src/common/components/Button';
import { colors } from 'src/config/colors';
import { GatsbyLink } from 'src/common/migration/GatsbyLink';
import { SearchRoute } from 'src/search/routes';
import { AboutUsRoute } from 'src/public/publicRoutes';

const Content = styled.div`
  max-width: 24rem;

  ${media.w.min.px768(css`
    padding-bottom: 1.625rem;
  `)};

  ${media.w.min.px992(css`
    max-width: none;
    padding-bottom: 0;
  `)};
`;

const Text = styled.div`
  margin: 1.25rem 0;
`;

const AboutUsLink = styled(Button)`
  color: ${colors.blue07};
  font-weight: 300;
  font-size: 0.625rem;
  line-height: 0.875rem;
  margin-top: 1.25rem;
`;

export const UserCoursesUpcomingEmpty: FC = () => {
  const isMobile = useMediaQuery({ maxWidth: below(widthBreakpoints.px768) });

  return (
    <Content>
      <Text>
        <strong>Gdy zapiszesz się na wybrane szkolenie, pojawi się ono w&nbsp;tym miejscu.</strong>
        <br />
        Tutaj również możesz sprawdzić datę szkolenia, jego status oraz dołączyć gdy trwa.
      </Text>

      <div>
        <Button size={isMobile ? 'tiny' : 'default'} as={GatsbyLink} to={SearchRoute}>
          Odkrywaj szkolenia
        </Button>
      </div>

      <div>
        <AboutUsLink decoration="underline" kind="link" as={GatsbyLink} to={AboutUsRoute}>
          Jak działa PFP?
        </AboutUsLink>
      </div>
    </Content>
  );
};
